import { DESKTOP_MIN_WIDTH } from 'constants';
import React from 'react';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';

const OuterPathContent = ({ children, style = {} }) => {
  return (
    <OuterPathContentStyled style={style}>{children}</OuterPathContentStyled>
  );
};

const OuterPathContentStyled = styled.div`
  border-radius: 0 0 20px 20px;
  border: none;
  padding: 16px;
  background: #fff;
  margin-top: -16px;
  margin-inline: -16px;
  box-shadow: 0px 4px 15px 0px #0000001a;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    border-radius: 12px;
    border: 1px solid var(--ds-c-blue-remox-light);
    padding: 24px 40px;
    background: #fff;
    margin-top: unset;
    margin-inline: unset;
    box-shadow: none;
  }
`;

export const Title = styled.h1`
  ${paragraphMixin};
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  text-transform: uppercase;
  color: #000;
  margin-bottom: 0px;

  display: flex;
  align-items: center;
  gap: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const TitleMobile = styled.h1`
  ${paragraphMixin};
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  text-align: left;
  text-transform: uppercase;
  color: #000;
  margin-bottom: 0px;

  display: flex;
  align-items: center;
  gap: 8px;
  margin-inline: -16px;
  height: 56px;
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding-inline: 16px;
  box-shadow: 0px 4px 15px 0px #0000001a;
`;

export const SubTitle = styled.h1`
  ${paragraphMixin};
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: left;
  text-transform: uppercase;
  color: #000;
  margin-bottom: 0px;
`;

export const DateTimeSection = styled.div`
  ${paragraphMixin};
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--ds-c-black);

  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  margin-bottom: 4px;
  margin-top: 4px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    align-items: flex-end;
    height: 50px;
    margin-bottom: 20px;
    margin-top: 0px;
  }
`;

export const SearchFilterSection = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  gap: 4px;
  padding-top: 16px;
  margin-bottom: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 8px;
    margin-top: 66px;
    padding-top: unset;
    ${(props) => props.styled};
  }
`;

export default OuterPathContent;
